var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 3.99998H14.6663V5.33331H13.333V14C13.333 14.1768 13.2628 14.3464 13.1377 14.4714C13.0127 14.5964 12.8432 14.6666 12.6663 14.6666H3.33301C3.1562 14.6666 2.98663 14.5964 2.8616 14.4714C2.73658 14.3464 2.66634 14.1768 2.66634 14V5.33331H1.33301V3.99998H4.66634V1.99998C4.66634 1.82317 4.73658 1.6536 4.8616 1.52858C4.98663 1.40355 5.1562 1.33331 5.33301 1.33331H10.6663C10.8432 1.33331 11.0127 1.40355 11.1377 1.52858C11.2628 1.6536 11.333 1.82317 11.333 1.99998V3.99998ZM11.9997 5.33331H3.99967V13.3333H11.9997V5.33331ZM5.99967 7.33331H7.33301V11.3333H5.99967V7.33331ZM8.66634 7.33331H9.99967V11.3333H8.66634V7.33331ZM5.99967 2.66665V3.99998H9.99967V2.66665H5.99967Z",
    fill: "#D9BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.236434960182cdf066d627d15273333e.svg";
export { ForwardRef as ReactComponent };